import React from 'react'
import {useIntl} from 'react-intl'
import {SupplierUser} from '../core/_models'

interface UserActionsCellProps {
  user: SupplierUser
  onEdit: (user: SupplierUser) => void
  onDelete: (userId: number) => void
}

const UserActionsCell: React.FC<UserActionsCellProps> = ({
  user,
  onEdit,
  onDelete,
}) => {
  const intl = useIntl()

  return (
    <div className='d-flex justify-content-end flex-shrink-0'>
      <button
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
        onClick={() => onEdit(user)}
        title={intl.formatMessage({id: 'USERS.EDIT_USER'})}
      >
        <i className='fas fa-edit'></i>
      </button>
      <button
        className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
        onClick={() => onDelete(user.supplier_user_id)}
        title={intl.formatMessage({id: 'USERS.DEACTIVATE_USER'})}
      >
        <i className='fas fa-trash'></i>
      </button>
    </div>
  )
}

export {UserActionsCell}
